import { render, staticRenderFns } from "./JdsNavigatorLayout.vue?vue&type=template&id=3590e200&scoped=true&"
import script from "./JdsNavigatorLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorLayout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNavigatorLayout.vue?vue&type=style&index=0&id=3590e200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3590e200",
  null
  
)

export default component.exports